/** Idade mínima para cadastro (alinhado à mensagem do assistente). */
export const MIN_SIGNUP_AGE = 16;

export type CadastroStep =
  | "nome"
  | "email"
  | "senha"
  | "nascimento"
  | "telefone"
  | "cpf"
  | "cep"
  | "numero"
  | "complemento"
  | "cartao_numero"
  | "cartao_titular"
  | "cartao_mes"
  | "cartao_ano"
  | "cartao_cvv"
  | "success";

export const BOT_QUESTIONS: Record<Exclude<CadastroStep, "success">, string> = {
  nome: "Qual é o seu nome completo?",
  email: "Qual é o seu e-mail?",
  senha:
    "Crie uma senha com pelo menos 8 caracteres (ela será usada para entrar no app).",
  nascimento: "Qual é a sua data de nascimento?",
  telefone: "Qual é o seu celular com DDD?",
  cpf: "Qual é o seu CPF?",
  cep: "Informe o seu CEP para buscarmos o endereço automaticamente.",
  numero: "Agora, qual é o número do endereço?",
  complemento:
    "Tem complemento? (apto, bloco, sala). Se não tiver, responda: sem complemento.",
  cartao_numero: "Número do cartão de crédito, por favor.",
  cartao_titular: "Nome impresso no cartão.",
  cartao_mes: "Mês de validade (MM).",
  cartao_ano: "Ano de validade (AA).",
  cartao_cvv: "CVV do cartão.",
};

export const STEP_TITLES = [
  "Nome",
  "E-mail",
  "Senha",
  "Nascimento",
  "Telefone",
  "CPF",
  "Endereço",
  "Cartão",
];

export const INPUT_LABELS: Record<Exclude<CadastroStep, "success">, string> = {
  nome: "Nome completo",
  email: "E-mail",
  senha: "Senha",
  nascimento: "Data de nascimento",
  telefone: "Celular com DDD",
  cpf: "CPF",
  cep: "CEP",
  numero: "Número",
  complemento: "Complemento",
  cartao_numero: "Número do cartão",
  cartao_titular: "Nome no cartão",
  cartao_mes: "Mês (MM)",
  cartao_ano: "Ano (AA)",
  cartao_cvv: "CVV",
};
